import {React, useEffect} from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const FancyBoxGallery = (props) => {

let storage_url = process.env.REACT_APP_CMS_STORAGE_URL

useEffect(() => {
    Fancybox.bind("[data-fancybox]", {});

    // Cleanup function to unbind Fancybox when the component unmounts
    return () => {
      Fancybox.destroy();
    };

}, []);

  return (

       <div
          className="row portfolio-list sort-destination"
          data-sort-id="portfolio"
        >
        {props?.setting?.home_images_sections.map((imageObj,index) => {
                const imageUrl = `${storage_url}${imageObj.image}`; // Set the image URL here
                
                return (
                  <div className="col-md-6 col-lg-3 m-0 p-0 websites" key={index}>
                    <div className="portfolio-item m-0">
                      <a
                        href={imageUrl} // Updated to use full image URL
                        data-fancybox="gallery"
                        data-caption={`${imageObj.title}: ${imageObj.content}`}
                      >
                        <span className="thumb-info thumb-info-centered-info thumb-info-no-borders border-radius-0 m-0">
                          <span className="thumb-info-wrapper border-radius-0">
                            <img
                              src={imageUrl} // Updated to use full image URL
                              className="img-fluid border-radius-0"
                              alt={imageObj.title || "Gallery Image"}
                            />
                            <span className="thumb-info-action">
                              <span className="thumb-info-action-icon bg-dark opacity-8">
                                <i className="fas fa-plus" />
                              </span>
                            </span>
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                );
            }
        )}

    </div>
  );
};


export default FancyBoxGallery;
